import styles from "./filter-number.module.css";
import { useState, useEffect } from "react";
import { Space, InputNumber, Checkbox, Flex, Typography } from "antd";
import CustomLabel from "@/components/inputs/CustomLabel";
import {
  isIntegerInputInRange,
  isNumberInputInRange,
  NUMBER_INPUT_RANGE_MESSAGE,
} from "@/utils/fieldValueConverter";

const EMPTY_VALUE = "notFilled";

const FilterNumber = ({
  value,
  label,
  onSubmit,
  fromTo = true,
  allowEmpty = false,
  type = "float",
}) => {
  const [val, setVal] = useState(value);
  const [isEmpty, setIsEmpty] = useState(value === EMPTY_VALUE);
  const validateValue =
    type === "integer" ? isIntegerInputInRange : isNumberInputInRange;
  const rangeMessage = NUMBER_INPUT_RANGE_MESSAGE;

  useEffect(() => {
    setVal(value === EMPTY_VALUE ? null : value);
    setIsEmpty(value === EMPTY_VALUE);
  }, [value]);

  const handleSubmit = (nextVal = val, nextEmpty = isEmpty) => {
    const values = fromTo ? [nextVal?.from, nextVal?.to] : [nextVal];
    if (!nextEmpty && values.some((item) => !validateValue(item))) {
      return;
    }

    if (nextEmpty) {
      onSubmit?.(EMPTY_VALUE);
    } else {
      onSubmit?.(nextVal);
    }
  };

  const handleEmptyChange = (e) => {
    const checked = e.target.checked;
    setIsEmpty(checked);

    if (checked) {
      handleSubmit(null, true);
    } else {
      handleSubmit(val, false);
    }
  };

  return (
    <div>
      <CustomLabel text={label} />

      <Flex gap={8} align="center">
        {fromTo ? (
          <Space.Compact className="w-100">
            <InputNumber
              placeholder="от"
              value={val?.from}
              status={validateValue(val?.from) ? undefined : "error"}
              precision={type === "integer" ? 0 : undefined}
              disabled={isEmpty}
              onChange={(newValue) =>
                setVal((prev) => ({ ...prev, from: newValue }))
              }
              onPressEnter={() => handleSubmit()}
              onBlur={() => handleSubmit()}
              className={styles.inputNumber}
            />

            <InputNumber
              placeholder="до"
              value={val?.to}
              status={validateValue(val?.to) ? undefined : "error"}
              precision={type === "integer" ? 0 : undefined}
              disabled={isEmpty}
              onChange={(newValue) =>
                setVal((prev) => ({ ...prev, to: newValue }))
              }
              onPressEnter={() => handleSubmit()}
              onBlur={() => handleSubmit()}
              className={styles.inputNumber}
            />
          </Space.Compact>
        ) : (
          <InputNumber
            placeholder="Введите число"
            value={val}
            status={validateValue(val) ? undefined : "error"}
            precision={type === "integer" ? 0 : undefined}
            disabled={isEmpty}
            onChange={(newValue) => setVal(newValue)}
            onPressEnter={() => handleSubmit()}
            onBlur={() => handleSubmit()}
            className={styles.inputNumber}
          />
        )}

        {allowEmpty && (
          <Checkbox
            style={{ width: 165 }}
            checked={isEmpty}
            onChange={handleEmptyChange}
          >
            Не заполнено
          </Checkbox>
        )}
      </Flex>
      {!isEmpty &&
        (fromTo
          ? !validateValue(val?.from) || !validateValue(val?.to)
          : !validateValue(val)) && (
          <Typography.Text type="danger" style={{ fontSize: 12 }}>
            {rangeMessage}
          </Typography.Text>
        )}
    </div>
  );
};

export default FilterNumber;
